<template>
    <div class="campaigns">
        <breadcrumbs :breadcrumbsData="breadcrumbsData" #icon>
            <svg class="icon" aria-hidden="true">
                <use xlink:href="#icon-a-PaidPlacement" style="color: #fff;"></use>
            </svg>
        </breadcrumbs>
       
        <div class="content-wrapper">
            <div class="tags">
            <div class="item lifetime">
                <span class="line"></span>
                <div class="text">
                    <span class="name">
                        Lifetime Placements Earnings
                        <!-- <svg class="icon artmisads-select-down-icon" aria-hidden="true">
                            <use xlink:href="#icon-shijian-xuxian"></use>
                        </svg> -->
                    </span>
                    <span class="num"> ${{ earnings?.lifetimePlacementsEarnings }}</span>
                </div>
            </div>
            <div class="item open">
                <span class="line"></span>
                <div class="text">
                    <span class="name">
                        Open Earnings
                        <!-- <svg class="icon artmisads-select-down-icon" aria-hidden="true">
                            <use xlink:href="#icon-shijian-xuxian"></use>
                        </svg> -->
                    </span>
                    <span class="num">${{ earnings?.openEarnings }}</span>
                </div>
            </div>
            <div class="item pending">
                <span class="line"></span>
                <div class="text">
                    <span class="name">
                        Pending Payment
                        <!-- <svg class="icon artmisads-select-down-icon" aria-hidden="true">
                            <use xlink:href="#icon-shijian-xuxian"></use>
                        </svg> -->
                    </span>
                    <span class="num"> ${{ earnings?.pendingPayment }}</span>
                </div>
            </div>
            </div>
            <div class="table-head">
                <a-space class="filters">
                    <a-input-search v-model:value="keyword" placeholder="Search..." allow-clear @search="onSearch"
                        @enter="onSearch">
                    </a-input-search>

                    <div class="statusFilter">
                        <span style="margin-right: 8px;">Status:</span>
                        <div ref="statusFilterRef" style="position: relative;">
                            <artmisads-select v-model:value="status" style="width: 220px;" @change="onStatusChange"
                                trigger="click" :getPopupContainer="() => $refs.statusFilterRef">
                                <a-select-option value="">All</a-select-option>
                                <a-select-option value="pending">Pending</a-select-option>
                                <a-select-option value="suspended">Suspended</a-select-option>
                                <a-select-option value="declined">Declined</a-select-option>
                                <a-select-option value="accepted">Accepted</a-select-option>
                                <a-select-option value="cancelled">Canceled</a-select-option>
                                <a-select-option value="paid">In Progress</a-select-option>
                                <a-select-option value="confirming">Confirming</a-select-option>
                                <a-select-option value="confirmed">Published</a-select-option>

                                <!-- <a-select-option value="published">Published</a-select-option> -->
                                <a-select-option value="completed">Payment Received</a-select-option>
                            </artmisads-select>
                        </div>

                    </div>
                </a-space>
            </div>
            <artmisads-table :loading="loading" :columns="columns" :data-source="dataSource" :pagination="{
                total: tableTotal,
                current: params.page,
                pageSize: params.size,
                showTotal: (total, range) => `Total ${total} items`,
                showSizeChanger: true,
                pageSizeOptions: ['10', '20', '50', '100', '200']
            }" :change="onChangePage">
                <template #bodyCell="{ column, text, index, record }">
                    <template v-if="column.key === 'applyDate'">
                        {{ setTime(record.applyDate) }}
                    </template>
                    <template v-if="column.key === 'status'">
                        <PlacementStatus :type="statusInfo[record.status]?.type || '--'"
                            :text="statusInfo[record.status]?.text || '--'" />
                    </template>
                    <template v-if="column.key === 'action'">
                        <artmisads-select-button size="small" @click="view(record, 'view')">
                            View
                        </artmisads-select-button>
                        <artmisads-select-button
                            v-if="record.status === 'accepted' || record.status === 'paid' || record.status === 'confirming'"
                            style="margin-left: 8px;" size="small" @click="Messages(record, 'Messages')">
                            Messages
                        </artmisads-select-button>
                    </template>
                </template>
            </artmisads-table>
        </div>
    </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import breadcrumbs from '@/components/breadcrumbs.vue'
import { publisherCampaignsApi } from '@/server'
import { useRouter } from 'vue-router'
import { useMessageDrawerStore } from '@/storeData/messageDrawer'
import { statusInfo } from '@/contants/common'
import PlacementStatus from '@/components/placementStatus.vue'
import { setTime } from '~/utils'
const store = useMessageDrawerStore()
const router = useRouter()
const breadcrumbsData = {
    title: "Campaigns",
    des: "Manage your placements campaigns information",
    color: '#80C026',
    hasTitleIcon: true,
    links: [
        {
            name: "Home",
            path: "/publisher/dashboard",
        },
        {
            name: "Paid Placement",
            path: "/publisher/settings/paidPlacement",
        },
        {
            name: "Campaigns",
            path: "/publisher/settings/paidPlacement/campaigns",
        },
    ],
}
const columns = ref([
    {
        title: 'Title',
        dataIndex: 'title',
        key: 'title',
    },
    {
        title: 'PlacementName',
        dataIndex: 'placementName',
        key: 'placementName',
    },
    {
        title: 'Brand',
        dataIndex: 'brandName',
        key: 'brandName',
    },
    {
        title: 'RequestDescription',
        dataIndex: 'placementDescription',
        key: 'placementDescription',
    },
    {
        title: 'Status',
        dataIndex: 'status',
        key: 'status',
    },
    {
        title: 'RequestDate',
        dataIndex: 'applyDate',
        key: 'applyDate',
    },
  
    {
        title: 'Action',
        dataIndex: 'action',
        name: 'action',
        key: 'action',
        fixed: 'right',
        width: 250,
    }
])
const dataSource = ref([])
const loading = ref(false)
const earningsLoading = ref(false)
const tableTotal = ref(0)
const params = ref({
    page: 1,
    size: 10,
    keyword: '',
    status: ''
})
const earnings = ref({
    lifetimePlacementsEarnings: 0,
    openEarnings: 0,
    pendingPayment: 0
})
const keyword = ref('')
const status = ref('')

const init = async () => {
    loading.value = true
    const { data } = await publisherCampaignsApi.getCampaigns(params.value)
    dataSource.value = data.data
    tableTotal.value = data.total
    loading.value = false
}
const initEarnings = async () => {
    earningsLoading.value = true
    const { data } = await publisherCampaignsApi.getCampaignsEarnings()

    earnings.value = data
    earningsLoading.value = false
}

// 添加缺失的函数
const onSearch = () => {
    params.value.keyword = keyword.value
    params.value.page = 1
    // 这里可以添加搜索逻辑
    init()
}

const onStatusChange = () => {
    params.value.status = status.value
    params.value.page = 1
    // 这里可以添加状态筛选逻辑
    init()
}
const view = (record, type) => {
    console.log(record, type)
    router.push(`/publisher/settings/paidPlacement/campaigns/${record.id}`)
}
const Messages = (record, type) => {
    const conversationPartnerId = record.conversationPartnerId
    store.show(conversationPartnerId)
}
const onChangePage = (pagination) => {
    params.value.page = pagination.current
    params.value.size = pagination.pageSize
    init()
    // 这里可以添加分页逻辑
}
onMounted(async () => {
    init()
    initEarnings()
})
</script>

<style scoped lang="less">
.tags {
    display: flex;
    margin: 16px 0;

    .item {
        background-color: var(--bg-gray-8);
        border-radius: 8px;
        display: flex;
        width: 25%;
        padding: 12px 14px 12px 0;

        &:nth-child(n+2) {
            margin-left: 16px;
        }

        .line {
            width: 4px;
            height: 56px;
            opacity: 0.85;
            border-radius: 3px;
        }

        .text {
            display: flex;
            flex-direction: column;
            flex: 1;
            margin-left: 12px;

            .name {
                font-weight: 500;
                font-size: 13px;
                color: var(--dark-2);
                letter-spacing: 0.3px;
                line-height: 20px;
                margin-bottom: 9px;
                display: flex;
                justify-content: space-between;

                svg {
                    width: 16px;
                    height: 16px;
                    align-self: center;
                }
            }

            .num {
                color: var(--dark-1);
                font-weight: 600;
                font-size: 20px;
                letter-spacing: 0.5px;
                line-height: 26px;
            }
        }
    }

    .lifetime {
        .line {
            background-color: var(--tag-bg-5);
        }

        svg {
            fill: var(--dark-2);
        }
    }

    .open {
        .line {
            background-color: var(--tag-bg-2);
        }
    }

    .pending {
        

        .line {
            background-color: var(--tag-bg-7);
        }

    }

    .commission {
        .line {
            background-color: var(--green-8);
        }

        svg {
            fill: var(--green-5);
        }
    }
}

.campaigns {
    padding: 16px;
    padding-top: unset;
    width: 100%;

    .filters {
        display: flex;
        justify-content: space-between;

        .statusFilter {
            margin-left: 16px;
            display: flex;
            align-items: center;
        }

    }

    .content-wrapper {
        display: block !important;

        .blue {
            background-color: #d0f1ff;

            .top-item-inner {
                border-left: 6px solid #55cfff;
            }
        }

        .green {
            background-color: #EAF7F0;

            .top-item-inner {
                border-left: 6px solid #009947;
            }
        }

        .yellow {
            background-color: #FFF7EB;

            .top-item-inner {
                border-left: 6px solid #E68200;
            }
        }

        .top-wrapper {
            display: flex;
            gap: 72px;
            align-items: center;

            .top-item {
                min-width: 280px;

                border-radius: 8px;

                .top-item-inner {
                    margin: 20px 0;
                    padding: 5px 10px;


                    .top-item-inner-title {
                        font-size: 16px;
                        font-weight: 600;

                    }

                    .top-item-inner-value {
                        font-size: 16px;
                        font-weight: 600;
                        margin-top: 6px;
                    }
                }

            }
        }

        .table-head {
            display: flex;
            height: 64px;
            justify-content: space-between;
            align-items: center;
        }
    }
}
</style>